import React, { useEffect, useState } from "react";
import "./Quotationcard.css";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import ModalComponent from "../../../Components/Features/ModalComponent";
import { Images, careSupremeBenefits, productDetails } from "../../../Data/Benifits";
import {
  Tooltip,
  LinearProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  updatedQuotationResult,
  updatePremiumPostObject,
  setSelectedProvider,
  storeQuote
} from "../../../../Redux/Health/action";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { fetchQuotationDataHelper,processQuoteData } from "../../../utils/quotationHelper";

const RelianceCard = ({  collectData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productFeatures, setProductFeatures] = useState([]);
  const [premium, setPremium] = useState(null);
  const [image, setImage] = useState(null);
  const selfGender = useSelector((state)=>state?.healthReducer?.proposerGender)

  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const premiumPostBody = useSelector(
    (state) => state?.healthReducer?.premiumPostObject
  );

  const roomRentMapping = {
    5: ["Twin sharing"],
    10: ["Actuals", "Twin sharing"],
    15: ["Actuals", "Twin sharing"],
    20: ["Actuals", "Twin sharing"],
    25: ["Single AC Private Room"],
    30: ["Single AC Private Room"],
    50: ["Single AC Private Room"],
    100: ["Single AC Private Room"],
  };
  const selectedCoverage = premiumPostBody?.selectedCoverage || "";
  const roomRentOptions = roomRentMapping[selectedCoverage] || [];

  const [postBody, setPostBody] = useState(premiumPostBody);

  const handleChange = (e) => {
    collectData(e.target.checked, quote);
  };
  useEffect(() => {
    fetchQuotationDataHelper({
      postBody,
      provider: "reliance", 
      extraParams: {
        selfGender,                
      },
      selectedCoverage: premiumPostBody?.selectedCoverage,
      setLoading,
      setQuote,
      productname:"Reliance Gain",
    });
  }, [postBody,selfGender,premiumPostBody?.selectedCoverage]);

  useEffect(() => {
    setPostBody(premiumPostBody);
  }, [premiumPostBody]);

  const handleModal = () => {
    setModalOpen(!modalOpen);
  };
  useEffect(() => {
    if (quote) {
      processQuoteData({
        quote,
        setProductFeatures,
        setImage,
        setPremium,
        productDetails,
        Images,
        dispatch,
        storeQuote,
      });
    }
  }, [quote,dispatch]);
  

  const handleNavigate = (quote) => {
    let provider = quote.provider;

    let code = quote.code;
    const updatedPostBody = {
      ...postBody,
      provider: provider,
      abacusId: code,
    };
    navigate("/health/proposalform");
    dispatch(updatedQuotationResult(quote));
    dispatch(setSelectedProvider(provider));

    dispatch(updatePremiumPostObject(updatedPostBody));
  };

 const handleCheckboxChange = (name, checked) => {
  let updatedPostBody = { ...postBody };

  if (name === "roomRentType" || name === "DeductibleGain" ||name==="PEDGainRange" || name==="CashLimitGain") {
    updatedPostBody[name] = checked;
  } else if (name === "SelectedDeductible") {
    updatedPostBody[name] = checked ? true : false;

    
    if (checked && !updatedPostBody["DeductibleGain"]) {
      updatedPostBody["DeductibleGain"] = "10000";
    }

    // Clear if unchecked
    if (!checked) {
      updatedPostBody["DeductibleGain"] = "";
    }
  } else if (name === "RoomRent") {
    updatedPostBody[name] = checked ? true : false;
    if (checked && roomRentOptions.length > 0) {
      updatedPostBody["roomRentType"] = roomRentOptions[0]; // default to first option
    }
    if (!checked) {
      updatedPostBody["roomRentType"] = "";
    }
  } else if(name==="PEDGain"){
updatedPostBody[name] = checked ? true : false;
if (
    checked &&
    (!updatedPostBody["PEDGainRange"]|| updatedPostBody["PEDGainRange"] === "")
  ) {
    updatedPostBody["PEDGainRange"] = "12";
  }
if(!checked) updatedPostBody["PEDGainRange"]=""
  }
  else if(name==="HospitalCashLimit"){
   updatedPostBody[name] = checked ? true : false;
   if(checked & !updatedPostBody["CashLimitGain"]) {
     updatedPostBody["CashLimitGain"] = "1000";

   }
    if (!checked) {
      updatedPostBody["CashLimitGain"] = "";
    }
  }  
  else {
    updatedPostBody[name] = checked ? true : false;
  }

  setPostBody(updatedPostBody);
};

  return (
    <>
      <ModalComponent
        open={modalOpen}
        handleClose={handleModal}
        quote={quote}
        features={careSupremeBenefits}
      />
      {loading ? (
        <LinearProgress />
      ) : (
      (quote && quote?.premiumWithGST &&quote?.premiumWithGST !=="0" ) && (
        <div className="health_quotation_main_card  mb_25 ">
          <div className="mt-2">
            <input
              className="form-check-input"
              onChange={(e) => handleChange(e)}
              type="checkbox"
              style={{
                fontSize: "25px",
                marginLeft: "10px",
                border: "1px solid",
              }}
            />
          </div>
          <div className="d_flex quotation_upr_div">
            <div className="logo_container">
              <img src={image} alt="CARE HEALTH" className="logo_box" />
            </div>

            <div className="quotation_content">
              <div className="content_box_cs">
                <div className="plane_name plan_details">
                  <div className="title_pa">{quote?.productName}</div>
                  <div className="suminsured_text">
                    Sum Insured : ₹{quote?.sumInsured}
                  </div>
                  <b>{quote?.term || quote?.tenure} year policy</b>
                </div>

                <div className="plan_feature plan_details">
                  <div
                    className="health_check_compare"
                    style={{ marginRight: "30px" }}
                  >
                    <ul className="features_list">
                      {productFeatures?.slice(0, 4)?.map((item, i) => (
                        <li key={i} className="font-12">
                          <Tooltip title={item.benefit} placement="right-start">
                            <HealthAndSafetyIcon
                              fontSize="small"
                              style={{ marginRight: "5px", color: "#03a9f4" }}
                            />
                            <span className="font-blue">{item.feature}</span>
                          </Tooltip>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="health_check_compare">
                    <ul className="features_list">
                      {productFeatures?.slice(4, 8)?.map((item, i) => (
                        <li key={i} className="font-12">
                          <Tooltip title={item.benefit} placement="right-start">
                            <HealthAndSafetyIcon
                              fontSize="small"
                              style={{ marginRight: "5px", color: "#03a9f4" }}
                            />
                            <span className="font-blue">{item.feature}</span>
                          </Tooltip>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div  onClick={() => handleNavigate(quote)} className="text_right hal_buy_btn_btn plan_details buy_btn">
                  {/* <a onClick={() => handleNavigate(quote)} className="buy_btn"> */}
                    <Tooltip title="Buy Plan" placement="bottom">
                      <span>
                        <i className="fa-solid fa-indian-rupee-sign mr_5"></i>₹{" "}
                        {premium}
                      </span>
                    </Tooltip>
                    <p>*Including GST</p>
                    <small>BUY NOW</small>
                  {/* </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="d_flex quotation_bottom_div">
            <button onClick={handleModal} className="features_btn">
              View Features <ChevronRightIcon />
            </button>
          </div>

          <div className="add_addon_div">
            <div className="d_flex addons_flex_container">
              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.FamilyCareCover)}
                    type="checkbox"
                    name="FamilyCareCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Family Care Cover</span>
                </label>
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.SmartCover)}
                    type="checkbox"
                    name="SmartCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Smart Cover</span>
                </label>
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.PreventiveCover)}
                    type="checkbox"
                    name="PreventiveCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Preventive Cover</span>
                </label>
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.ConvienceCover)}
                    type="checkbox"
                    name="ConvienceCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Convenience Cover</span>
                </label>
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.EnhancedCover)}
                    type="checkbox"
                    name="EnhancedCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Enhance Cover</span>
                </label>
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.DoubleCover)}
                    type="checkbox"
                    name="DoubleCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Double Cover</span>
                </label>
              </div>



              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.HospitalCashLimit)}
                    type="checkbox"
                    name="HospitalCashLimit"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Hospital Cash Limit</span>
                </label>

                {
  postBody.HospitalCashLimit &&(
     <select
                    name="CashLimitGain"
                    value={postBody?.CashLimitGain}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value=" ">Select Cash Limit</option>
                    
                      <option value="1000" >1000</option>
                      <option value="1500">15000</option>
                      <option value="2000">20000</option>
                      <option value="2500">25000</option>

                 
                  </select>
                )}
              </div>



 

{
    premiumPostBody.highestElderAge>"60" &&(
      <div className="health_addons_input_box">
      <label>
        <input
          checked={Number(postBody?.RemovalOfCoPayment)}
          type="checkbox"
          name="RemovalOfCoPayment"
          onChange={(e) =>
            handleCheckboxChange(e.target.name, e.target.checked)
          }
        />
        <span>RemovalOfCopayment</span>
      </label>
    </div>

    )
}

             
              <div
                className="health_addons_input_box"
                style={{ marginBottom: "20px" }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "8px",
                    fontWeight: "500",
                  }}
                >
                  <input
                    type="checkbox"
                    name="RoomRent"
                    checked={Number(postBody?.RoomRent)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                    style={{ transform: "scale(1.2)", cursor: "pointer" }}
                  />
                  <span>
Change in Room Rent Limits</span>
                </label>

                {postBody?.RoomRent && (
                  <select
                    name="roomRentType"
                    value={postBody?.roomRentType}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value=" ">Select Room Rent Type</option>
                    {roomRentOptions.map((roomRent, index) => (
                      <option key={index} value={roomRent}>
                        {roomRent}
                      </option>
                    ))}
                  </select>
                )}
              </div>






    <div
                className="health_addons_input_box"
                style={{ marginBottom: "20px" }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "8px",
                    fontWeight: "500",
                  }}
                >
                  <input
                    type="checkbox"
                    name="PEDGain"
                    checked={Number(postBody?.PEDGain)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                    style={{ transform: "scale(1.2)", cursor: "pointer" }}
                  />
                  <span>Reduction in PED Waiting Period Limit Required?</span>
                </label>
{postBody?.PEDGain && (
                  <select
                    name="PEDGainRange"
                    value={postBody?.PEDGainRange}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value=" ">Select PED Range</option>
                    
                      <option value="12" >12 Months</option>
                      <option value="24">24 Months</option>
                 
                  </select>
                )}
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    type="checkbox"
                    name="SelectedDeductible"
                    checked={Number(postBody?.SelectedDeductible)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />

                  <span>Voluntary Aggregate Deductible</span>
                </label>
                {postBody?.SelectedDeductible === true && (
                  <select
                    name="DeductibleGain"
                    value={postBody?.DeductibleGain}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value="10000">10000</option>
                    <option value="25000">25000</option>
                    <option value="50000">50000</option>
                    <option value="100000">100000</option>
                    {/* <option value="200000">200000</option>
                    <option value="300000">300000</option>
                    <option value="500000">500000</option> */}
                  </select>
                )}
              </div>






              
            </div>
          </div>
        </div>
      )
       )}
    </>
  );
};

export default RelianceCard;
